import { Config } from "../../../api/config";
export var AppointmentKeys = {
    InstallBase: "InstallBaseDetails",
    Paging: 'appointmentPaging',
    TranslateToJobItems: 'getTranslateToJobItems',
    ComplaintGroupBasedOnComplaintId: 'getComplaintGroupBasedOnComplaintId',
    SearchTranslatetoJobItem: 'getSearchTranslatetoJobItem'
};
export var channelInstallBaseURL = "".concat(Config.baseURL, "Installbase/ChannelInstallbaseData");
export var appointmentPagingURL = "".concat(Config.baseURL, "Appointment/Paging");
export var appointmentDetailsGetByIdAPI = function (id) { return "".concat(Config.baseURL, "Appointment/").concat(id, "/Get"); };
export var repairTypeListURL = "".concat(Config.baseURL, "ServiceType/ChannelList");
export var getCampaignListURL = "".concat(Config.baseURL, "CampaignMaster/ChannelListData");
export var validateAppointmentURL = "".concat(Config.baseURL, "Appointment/ValidateAppointment");
